import type { DataFile } from '../../../../../services/dataHubService.interface.js';

const JSON_TRANSCRIPT_SUFFIX = '-transcript.json';
const JSON_EXTENSION = '.json';
const TEXT_EXTENSION = '.txt';
const AUGMENTED_MARKER = 'augmented';
const TRANSCRIPT_FILE_TYPE = 'transcript';

function normalizedFileName(file: DataFile): string {
  return (file.fileName ?? '').trim().toLowerCase();
}

export function selectTranscriptFile(
  files: readonly DataFile[],
): DataFile | null {
  const candidates = files.filter((file) => {
    const fileName = normalizedFileName(file);
    return (
      file.fileType?.toLowerCase() === TRANSCRIPT_FILE_TYPE ||
      fileName.endsWith(JSON_EXTENSION) ||
      fileName.endsWith(TEXT_EXTENSION)
    );
  });

  return (
    candidates.find((file) =>
      normalizedFileName(file).endsWith(JSON_TRANSCRIPT_SUFFIX),
    ) ??
    candidates.find((file) => {
      const fileName = normalizedFileName(file);
      return (
        fileName.endsWith(JSON_EXTENSION) &&
        !fileName.includes(AUGMENTED_MARKER)
      );
    }) ??
    candidates.find((file) =>
      normalizedFileName(file).endsWith(TEXT_EXTENSION),
    ) ??
    null
  );
}
